<template>
  <form @submit.prevent="save" class="w-m-content page-editor" v-if="!loading && !errors">
    <div class="w-m-header">
      <div class="flex">
        <p class="font-14 font-bold no-margin col-grow" style="color: #293e52">Página do site</p>
        <div class="">
          <!--<u-btn size="sm" flat label="Variáveis" icon="eye" icon-type="fa" @click="$refs.vars.show()" />-->
        </div>
      </div>
      <!--<div class="m-t-xs font-13 text-grey-7" style="color: #748396; padding-right: 20px; line-height: 1">Esta seção
        autoriza uma pessoa a acessar o software, com suas respectivas permissões.
      </div>-->
    </div>
    <div class="w-m-body e-input-modern flex">
      <div style="min-height: 400px" class="flex column w-full">
        <show-all ref="vars" />
        <e-row class="m-b-sm font-bold">
          Nome (código curto) da página:
        </e-row>
        <e-row class="m-b-sm">
          <e-col>
            <erp-input autofocus simple-border required placeholder="Ex.: leilao, cadastro, sobre-nos"
                       v-model="model.pageName" />
          </e-col>
        </e-row>

        <e-row mr>
          <e-col>
            <e-row class="m-b-sm font-bold">
              Título da página:
            </e-row>
            <e-row class="m-b-sm">
              <e-col>
                <erp-input simple-border required placeholder="Ex.: Sobre nós"
                           v-model="model.title" />
              </e-col>
            </e-row>
          </e-col>
          <e-col>
            <e-row class="m-b-sm font-bold">
              Descrição sobre o página:
            </e-row>
            <e-row class="m-b-sm">
              <e-col>
                <erp-input simple-border required placeholder="Ex.: Conheça um pouco sobre nossa empresa" v-model="model.pageDescription" />
              </e-col>
            </e-row>
          </e-col>
        </e-row>

        <e-row mr>
          <e-col>
            <e-row class="m-b-sm m-t-n-xs font-bold">
              URL da página: (se aplicável)
            </e-row>
            <e-row class="m-b-sm">
              <e-col>
                <erp-input prefix="https://www.seudominio/pages/" simple-border v-model="model.url" />
              </e-col>
            </e-row>
          </e-col>
          <e-col style="max-width: 200px">
            <e-row class="m-b-sm m-t-n-xs font-bold">
              Utilizar layout padrão da página
            </e-row>
            <e-row class="m-b-sm">
              <e-col>
                <sl-checkbox v-model="model.herdarLayout" />
              </e-col>
            </e-row>
          </e-col>
        </e-row>

        <e-row v-show="!source" class="m-b-sm m-t col-grow flex">
          <e-col class="flex col-grow column">
            <div class="m-b font-bold w-full flex-zero">Conteúdo da página:</div>
            <div style="width: 100%; background-color: #FFFFFF; padding: 20px">
              <sl-editor
                  ref="editor"
                  v-model="model.template"
                  :show-toolbar-on-focus="true"
                  class="editor-campanha"
                  :close-click-outside="false"
                  disable-mark
                  @focus="() => { textEditing = true }"
              />
            </div>
          </e-col>
        </e-row>
        <e-row v-show="source">
          <e-col>
            <textarea class="w-full wrapper-sm" rows="10" v-model="model.template" />
          </e-col>
        </e-row>
<!--        <div class="flex items-center">
          <u-toggle v-model="source" class="m-r-sm" />
          Editar código fonte
        </div>-->


      </div>
    </div>
    <div class="w-m-footer text-right">
      <u-btn @click="excluir" v-if="id && !model.interno" label="Excluir" no-caps color="negative"
             class="b-radius-3px pull-left" />
      <u-btn type="submit" :label="id ? 'Atualizar' : 'Cadastrar'" :disable="!ready" no-caps
             :color="ready ? 'primary' : 'blue-grey-2'"
             class="b-radius-3px" />
    </div>
  </form>
  <window-loading :errors="errors" :status="status" v-else />
</template>

<script>
import ERow from '../../../../../layout/components/Row'
import {ErpInput} from 'uloc-vue-plugin-erp'
import ECol from '../../../../../layout/components/Col'
import {UEditor, UToggle} from 'uloc-vue'
import WindowSuccess from '../../../../../layout/window/Success'
import TimerCloseWindow from '../../../../../layout/window/TimerClose'
import WindowLoading from '../../../../../layout/window/Loading'
import {
  newConteudo as create,
  updateConteudo as update,
  find,
  deleteConteudo
} from '../../../../../../domain/conteudo-paginas/services'
import ShowAll from '../../../../../variaveis/components/showAll';
import SlEditor from "components/layout/components/Editor";
import SlCheckbox from "@/reuse/input/Checkbox.vue";

let mock = {
  id: null,
  title: null,
  pageName: null,
  pageDescription: null,
  url: null,
  template: '',
  herdarLayout: true
}

export default {
  name: 'PaginasWindowModern',
  components: {
    SlCheckbox,
    SlEditor,
    ShowAll,
    WindowLoading,
    ECol,
    ERow,
    ErpInput,
    //UEditor,
    // UToggle
  },
  props: ['props', 'id'],
  data () {
    return {
      model: JSON.parse(JSON.stringify(mock)),
      loading: !!this.id,
      errors: null,
      success: false,
      status: null,
      source: false,
      textEditing: false
    }
  },
  mounted () {
    this.id && this.load()
  },
  computed: {
    mock () {
      return mock
    },
    ready () {
      let model = this.model
      return !!(String(model.nome).length > 2 && model.template);

    }
  },
  methods: {
    load () {
      find(this.id)
        .then(response => {
          this.model = response.data
          this.loading = false
        })
        .catch(error => {
          this.alertApiError(error)
          this.loading = false
        })
    },
    excluir () {
      this.$uloc.dialog({
        title: `Tem certeza que deseja excluir esta página?`,
        message: 'Digite EXCLUIR e clique para confirmar:',
        prompt: {
          model: '',
          type: 'text' // optional
        },
        cancel: true,
        color: 'negative'
      }).then(data => {
        if (data.toUpperCase() !== 'EXCLUIR') {
          this.$uloc.notify({
            color: 'negative',
            message: `Você não confirmou a operação. Exclusão não efetuada.`
          })
          return
        }
        this.$uloc.notify({
          color: 'negative',
          message: `Excluindo template...`
        })
        deleteConteudo(this.id)
          .then(response => {
            this.$uloc.notify({
              color: 'positive',
              message: `Página deletada com sucesso!`
            })
            this.$uloc.window.emit(this.$root.wid, 'created', this.props)
            this.$uloc.window.close(this.$root.wid)
          })
          .catch(error => {
            this.alertApiError(error)
          })
      }).catch(() => {
      })
    },
    save () {
      console.log('Save')
      this.loading = true

      let data = this.model

      let method = this.id ? (data) => update(this.id, data) : create
      method(data)
        .then(({data}) => {
          this.success = true
          Object.assign(this.model, data)
          this.$nextTick(() => {
            this.$uloc.window.emit(this.$root.wid, 'created', this.props)
            this.dg()
            this.loading = false
            // this.$refs.timer.start()
          })
        })
        .catch(error => {
          this.success = false
          this.errorMessage = error.data.message
          // this.errors = this.systemError(error)
          this.$nextTick(() => {
            this.loading = false
            this.alertApiError(error)
            // this.error = true
          })
        })
    }
  }
}
</script>

<style lang="stylus">
.page-editor {
  .sl-editor-content {
    min-height 500px
  }
}
</style>
